import pagination from "../static/pagination";
import paginationMessage from "../static/paginationMessage";
import paginationTemplate from "../static/paginationTemplate";
import payloadCreateBlast from "../static/payloadCreateBlast";

const moduleName = "waBlastModule";

const state = {
	isFetching: false,
	isLoadMore: false,
	isFilter: false,
	response: {},
	pagination: pagination(),
	displayItem: [],
	lastPosition: {},
	endItemofPage: {},

	search: "",
	searchLoading: false,
	isSearch: false,

	listHistory: [],
	listHistoryTemp: [],
	totalHistory: 0,
	countTemplate: 0,

	detailHistory: {},
	listMessage: [],
	paginationMessage: paginationMessage(),

	listTemplate: [],
	totalTemplate: 0,
	detailTemplate: {},
	paginationTemplate: paginationTemplate(),

	listCustomer: [],
	totalCustomer: 0,

	payloadCreateBlast: payloadCreateBlast(),

	waDevice: [],
	selectedWaDevice: {
		iddevice: '',
		nama: '',
		number: ''
	},

	blastType: null,
	blastTypeId: null,
};

export {state as default, moduleName}